export default __webpack_public_path__ + "static/side-nav-do-1-f3cbf48c82bca6f40468749a265023223109dddebdfef3ad4d15ceec3441fc5c.png";